export default __webpack_public_path__ + "static/media/char_head_003.2e85a784.png";